import { Utilities } from '../Utilities';
frontendApp.filter('bytes', [() => Utilities.formatBytes]);
